import { render, staticRenderFns } from "./wall.vue?vue&type=template&id=19d12cf6"
import script from "./wall.vue?vue&type=script&lang=js"
export * from "./wall.vue?vue&type=script&lang=js"
import style0 from "./wall.vue?vue&type=style&index=0&id=19d12cf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports